<template>
  <v-container fluid fill-height class="login-background">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4" align="center" justify="center">
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{ $t("ResetPassword.Title") }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                prepend-icon="mdi-lock"
                name="firstPass"
                :label="$t('ResetPassword.NewPassword')"
                type="password"
                :rules="[
                  value =>
                    !!value || this.$i18n.t('Rules.NewPassword_required'),
                  value =>
                    (value && value.length >= 8) ||
                    this.$i18n.t('Rules.Password_length'),
                  value =>
                    /\d/.test(value) || this.$i18n.t('Rules.Password_number'),
                  value =>
                    /[a-z]/.test(value) || this.$i18n.t('Rules.Password_lower'),
                  value =>
                    /[A-Z]/.test(value) || this.$i18n.t('Rules.Password_upper')
                ]"
                v-model="firstPass"
                v-on:keyup.enter="ChangePassword"
              ></v-text-field>
              <v-text-field
                prepend-icon="mdi-lock"
                name="confirmPass"
                :label="$t('ResetPassword.ConfirmPassword')"
                type="password"
                :rules="[
                  v => !!v || $t('Rules.ConfirmPassword_required'),
                  v => v === firstPass || $t('Rules.ConfirmPassword_invalid')
                ]"
                v-model="confirmPass"
                v-on:keyup.enter="ChangePassword"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              v-on:click="ChangePassword"
              :disabled="!valid"
              :loading="isRequesting"
              >{{ $t("ResetPassword.Title") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AuthService from "@/services/AuthenticationService";

export default {
  data() {
    return {
      valid: false,
      isRequesting: false,
      firstPass: "",
      confirmPass: ""
    };
  },
  methods: {
    ChangePassword() {
      if (this.$refs.form.validate()) {
        this.isRequesting = true;

        var resetToken = {
          Token: this.$route.query.token,
          Password: this.firstPass
        };

        AuthService.ResetPassword(resetToken)
          .then(response => {
            this.$emit(
              "show-success",
              this.$i18n.t("Success.Password_changed")
            );
            this.$router.push({ name: "Login" });
          })
          .catch(e =>
            this.$emit(
              "show-error",
              this.$i18n.t("Error.Password_Change_Failed")
            )
          )
          .finally(() => (this.isRequesting = false));
      }
    }
  }
};
</script>

<style scoped>
.login-background {
  background-image: url(../assets/login_background.jpg);
  background-size: cover;
}
</style>
